module.exports = __webpack_public_path__ + "img/744.f358ea6a.jpg";